/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignRequestStatus = {
    Incomplete: 'Incomplete',
    Pending: 'Pending',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
} as const;
export type EsignRequestStatus = typeof EsignRequestStatus[keyof typeof EsignRequestStatus];


export function instanceOfEsignRequestStatus(value: any): boolean {
    for (const key in EsignRequestStatus) {
        if (Object.prototype.hasOwnProperty.call(EsignRequestStatus, key)) {
            if (EsignRequestStatus[key as keyof typeof EsignRequestStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignRequestStatusFromJSON(json: any): EsignRequestStatus {
    return EsignRequestStatusFromJSONTyped(json, false);
}

export function EsignRequestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignRequestStatus {
    return json as EsignRequestStatus;
}

export function EsignRequestStatusToJSON(value?: EsignRequestStatus | null): any {
    return value as any;
}

export function EsignRequestStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignRequestStatus {
    return value as EsignRequestStatus;
}

